import { isFleetHostCommandVerb, isFleetLaneCommandVerb, type FleetCommandView } from '@immo/api-contract';

/** The machine's unsettled host verb (`system-prune` included) — what replaces its host actions while it runs. */
export function pendingHostCommandFor(commands: ReadonlyArray<FleetCommandView>): FleetCommandView | null {
  return (
    commands.find(
      (command) =>
        command.outcome === 'accepted' && (isFleetHostCommandVerb(command.verb) || command.verb === 'system-prune'),
    ) ?? null
  );
}

/** The lane's unsettled `start` / `stop` / `restart`, read from the same array the feed renders. */
export function pendingLaneCommandFor(
  commands: ReadonlyArray<FleetCommandView>,
  profile: string,
): FleetCommandView | null {
  return (
    commands.find(
      (command) =>
        command.outcome === 'accepted' && command.profile === profile && isFleetLaneCommandVerb(command.verb),
    ) ?? null
  );
}
